import React from "react";
import loadable from "@loadable/component";
import Container from "../../common/UI/Container";
import "./index.scss";

const Row = loadable(() => import("./Row"));

const ProInstall = () => {
  return (
    <section className="PgESM-PI">
      <Container mode="standard">
        <h2 className="PgESM-PI__title">
          ¡Instala la Extensión PRO AI de AMZScout en solo 3 clics!
        </h2>
        <p className="PgESM-PI__subtitle">
          Obtén análisis detallados de productos de Amazon en tiempo real
        </p>
        <Row />
      </Container>
    </section>
  );
};

export default ProInstall;
